App.service('DialogService', function() {
    var _type,
        _title,
        _message,
        _timer,
        _html ,
        _showConfirmButton,
        _confirmButtonColor,
        _confirmButtonText,
        _showCancelButton,
        _closeOnConfirm,
        _showLoaderOnConfirm,
        _inputPlaceholder,
        _inputValue,
        _callback;

    var reset = function() {
        _type = null;
        _title = null;
        _message = null;
        _timer = null;
        _html = false;
        _showConfirmButton = true;
        _confirmButtonColor = '#8cc152';
        _confirmButtonText = 'OK';
        _showCancelButton = false;
        _closeOnConfirm = true;
        _showLoaderOnConfirm = false;
        _inputPlaceholder = '';
        _inputValue = null;
        _callback = null;
    };

    reset();

    var run = function() {
        swal({
            title: _title,
            text: _message,
            type: _type,
            timer: _timer,
            html: _html,
            showConfirmButton: _showConfirmButton,
            confirmButtonColor: _confirmButtonColor,
            confirmButtonText: _confirmButtonText,
            showCancelButton: _showCancelButton,
            closeOnConfirm: _closeOnConfirm,
            showLoaderOnConfirm: _showLoaderOnConfirm,
            inputPlaceholder: _inputPlaceholder,
            inputValue: _inputValue
        }, function(data) {
            if (_callback) {
                _callback(data);
            }
        });
    };

    this.success = function(message, title, callback) {
        reset();

        _type = 'success';
        _title = (title || 'Success');
        _message = message;
        _showConfirmButton = false;
        _timer = 3000;
        _callback = callback;

        run();
    };

    this.error = function(title, message, callback) {
        reset();

        _type = 'error';
        _title = (title || 'Error');
        _message = message;
        _showConfirmButton = true;
        _confirmButtonColor = '#ccc';
        _callback = callback;

        run();
    };

    this.confirm = function(title, message, callback) {
        reset();

        _type = 'warning';
        _title = 'Are you sure you want to ' + (title ? title : 'take this action') + '?';
        _message = (message || 'This action cannot be undone');
        _confirmButtonText = 'Confirm';
        _showCancelButton = true;
        _closeOnConfirm = false;
        _showLoaderOnConfirm = true;
        _callback = callback;

        run();
    };

    this.prompt = function(title, message, callback, input) {
        reset();

        _type = 'input';
        _title = (title || 'Write Something');
        _message = message;
        _showCancelButton = true;
        _closeOnConfirm = false;
        _showLoaderOnConfirm = true;
        _confirmButtonText = 'Submit';
        _inputPlaceholder = 'Write something';
        _inputValue = input;
        _callback = callback;

        run();
    };

    this.appendError = function(message) {
        swal.showInputError(message);
    };

    this.close = function() {
        swal.close()
    }
});
